import { Component, OnInit } from '@angular/core';
import { EtenderEvaluationService } from '../../../../shared/services/etenderEvaluation.service';
import { ETenderSupplierEvaluation } from '../../../../shared/models/e-tender.model';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from '../../../../shared/components/alert/alert.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';

@Component({
  selector: 'app-etender-evaluation',
  templateUrl: './etender-evaluation.component.html',
  styleUrls: ['./etender-evaluation.component.css']
})
export class EtenderEvaluationComponent implements OnInit {

  ETenderId: string;
  IshighPrice = false;
  IsNotInvolved = false;
  IsNotQualified = false;
  TenderSuppliersEvaluationLst: ETenderSupplierEvaluation[];
  constructor(private route: ActivatedRoute, private etenderEvalaution: EtenderEvaluationService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private translate: TranslateService) {
    if (history.state.data && history.state.data.tenderId) {
      this.ETenderId = history.state.data.tenderId;
    } else {
      window.history.back();
    }
  }

  ngOnInit() {
    this.globalSrv.isLoaderEnabled = true;
    this.etenderEvalaution.GetTenderSupplierEvaluation(this.ETenderId).subscribe(d => {
      this.globalSrv.isLoaderEnabled = false;
      this.TenderSuppliersEvaluationLst = d.Data;

      if (this.TenderSuppliersEvaluationLst.length == 0) {
        this.alertService.success(this.translate.instant('SHARED.NoItems'), false);

      }
    });
  }
  setTenderWinner() {
    this.IshighPrice = false;
    this.IsNotInvolved = false;
    this.IsNotQualified = false;
    this.globalSrv.isLoaderEnabled = true;
    this.alertService.clear();
    let winners = '';
    this.TenderSuppliersEvaluationLst.forEach(element => {
      if (element.IsWinner) {
        winners += this.TenderSuppliersEvaluationLst.filter(e => e.SupplierId == element.SupplierId)[0].Supplier.CompanyName + ', ';
        if (element.IsHighPrice) {
          this.IshighPrice = true;
        }
        if (!element.IsQualified) {
          this.IsNotQualified = true;
        }
        if (!element.IsSupplierInvolved) {
          this.IsNotInvolved = true;
        }
      }
    });
    if (!this.IshighPrice && !this.IsNotQualified && !this.IsNotInvolved) {
      this.etenderEvalaution.setTenderWinner(this.TenderSuppliersEvaluationLst).subscribe(
        (data: ResponseObject) => {
          this.globalSrv.isLoaderEnabled = false;
          if (data.Success) {
            winners = winners.substring(0, winners.length - 2);
            this.alertService.success(this.translate.instant('ADMIN_USER.E_TENDER_FORM.WINNERS_MESSAGE') + winners, false);
          } else {
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.InternalServerError'), false);
          }
        });
    } else {
      this.globalSrv.isLoaderEnabled = false;
      this.alertService.error(this.translate.instant('ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.WINNEERROR'), false);
      const el = document.getElementsByClassName('alert-danger');
      el[0].scrollIntoView({ behavior: 'smooth' });
    }
  }

  evaluateTender(e) {
    this.globalSrv.isLoaderEnabled = true;
    this.alertService.clear();
    this.IshighPrice = false;
    this.IsNotInvolved = false;
    this.IsNotQualified = false;
    if (e.IsWinner) {
      if (new Date(Date.now()) < new Date(this.TenderSuppliersEvaluationLst[0].ETender.OfferDeadline)) {
        this.globalSrv.isLoaderEnabled = false;
        this.alertService.error(this.translate.instant('ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.DEADLINE_ERROR'), false);
        const el = document.getElementsByClassName('alert-danger');
        el[0].scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (e.IsHighPrice) {
        this.IshighPrice = true;
      }
      if (!e.IsQualified) {
        this.IsNotQualified = true;
      }
      if (!e.IsSupplierInvolved) {
        this.IsNotInvolved = true;
      }
    }
    if (!this.IshighPrice && !this.IsNotQualified && !this.IsNotInvolved) {
      this.etenderEvalaution.evaluateETender(e).subscribe((data: ResponseObject) => {
        this.globalSrv.isLoaderEnabled = false;
        if (data.Success) {
          this.alertService.success(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.SAVEDSUCESSFULY'), false);
        } else {
          this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.InternalServerError'), false);
        }
      });
    } else {
      this.globalSrv.isLoaderEnabled = false;
      this.alertService.error(this.translate.instant('ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.WINNEERROR'), false);
      const el = document.getElementsByClassName('alert-danger');
      el[0].scrollIntoView({ behavior: 'smooth' });
    }
  }
}

